/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface QuoteGroupCarrierResult
 */
export interface QuoteGroupCarrierResult {
  /**
   *
   * @type {string}
   * @memberof QuoteGroupCarrierResult
   */
  carrierIdentifier: string;
  /**
   *
   * @type {string}
   * @memberof QuoteGroupCarrierResult
   */
  serviceIdentifier: string;
  /**
   *
   * @type {boolean}
   * @memberof QuoteGroupCarrierResult
   */
  success: boolean;
  /**
   *
   * @type {string}
   * @memberof QuoteGroupCarrierResult
   */
  message?: string | null;
  /**
   *
   * @type {string}
   * @memberof QuoteGroupCarrierResult
   */
  brokeredCarrierIdentifier?: string | null;
}

/**
 * Check if a given object implements the QuoteGroupCarrierResult interface.
 */
export function instanceOfQuoteGroupCarrierResult(
  value: object,
): value is QuoteGroupCarrierResult {
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (
    !("serviceIdentifier" in value) ||
    value["serviceIdentifier"] === undefined
  )
    return false;
  if (!("success" in value) || value["success"] === undefined) return false;
  return true;
}

export function QuoteGroupCarrierResultFromJSON(
  json: any,
): QuoteGroupCarrierResult {
  return QuoteGroupCarrierResultFromJSONTyped(json, false);
}

export function QuoteGroupCarrierResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuoteGroupCarrierResult {
  if (json == null) {
    return json;
  }
  return {
    carrierIdentifier: json["carrierIdentifier"],
    serviceIdentifier: json["serviceIdentifier"],
    success: json["success"],
    message: json["message"] == null ? undefined : json["message"],
    brokeredCarrierIdentifier:
      json["brokeredCarrierIdentifier"] == null
        ? undefined
        : json["brokeredCarrierIdentifier"],
  };
}

export function QuoteGroupCarrierResultToJSON(
  json: any,
): QuoteGroupCarrierResult {
  return QuoteGroupCarrierResultToJSONTyped(json, false);
}

export function QuoteGroupCarrierResultToJSONTyped(
  value?: QuoteGroupCarrierResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierIdentifier: value["carrierIdentifier"],
    serviceIdentifier: value["serviceIdentifier"],
    success: value["success"],
    message: value["message"],
    brokeredCarrierIdentifier: value["brokeredCarrierIdentifier"],
  };
}
